import { render, staticRenderFns } from "./UnfactoredClaimsControllers.vue?vue&type=template&id=198c390a&scoped=true&"
import script from "./UnfactoredClaimsControllers.vue?vue&type=script&lang=js&"
export * from "./UnfactoredClaimsControllers.vue?vue&type=script&lang=js&"
import style0 from "./UnfactoredClaimsControllers.vue?vue&type=style&index=0&id=198c390a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198c390a",
  null
  
)

export default component.exports